import LandingHeader from "@/components/landing/LandingHeader";
import LandingHero from "@/components/landing/LandingHero";
import LandingModules from "@/components/landing/LandingModules";
import LandingStudyTogether from "@/components/landing/LandingStudyTogether";
import LandingSocraticDemo from "@/components/landing/LandingSocraticDemo";
import LandingHomeworkPhotoHelp from "@/components/landing/LandingHomeworkPhotoHelp";
import LandingVoiceDemo from "@/components/landing/LandingVoiceDemo";
import LandingMastery from "@/components/landing/LandingMastery";
import LandingComparison from "@/components/landing/LandingComparison";
import LandingParentDashboard from "@/components/landing/LandingParentDashboard";
import LandingCurriculum from "@/components/landing/LandingCurriculum";
import LandingGamification from "@/components/landing/LandingGamification";
import LandingFAQ from "@/components/landing/LandingFAQ";
import LandingFooter from "@/components/landing/LandingFooter";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <LandingHeader />
      <LandingHero />
      <LandingModules />
      <LandingStudyTogether />
      <LandingSocraticDemo />
      <LandingHomeworkPhotoHelp />
      <LandingVoiceDemo />
      <LandingMastery />
      <LandingComparison />
      <LandingParentDashboard />
      <LandingCurriculum />
      <LandingGamification />
      <LandingFAQ />
      <LandingFooter />
    </div>
  );
}
